import { useContext } from 'react';
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import {
	JiraPreviewPanelsNavigationContext,
	defaultContext,
	type JiraPreviewPanelsNavigationContextValue,
} from './JiraPreviewPanelsNavigationContext.tsx';

export const useIssuePreviewPanelsNavigation: () => JiraPreviewPanelsNavigationContextValue =
	functionWithCondition(
		() =>
			expVal('nin_issue_preview_panel_navigation', 'isEnabled', false) ||
			fg('jivtech-1920-back-navigation-gpp'),
		() => useContext(JiraPreviewPanelsNavigationContext),
		() => defaultContext,
	);
